module.exports = __webpack_public_path__ + "static/media/aleister.d8201553.PNG";